<template>
  <div>
    <h1 class="page-header">{{ $t('product.product') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('product.nameKH') }}</label>
              <input
                type="text"
                v-model="model.product_name_kh"
                class="form-control"
                :class="{ 'is-invalid': errors.has('product_name_kh') }"
                :placeholder="$t('product.enterproductnameKH')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_name_kh')"
              >
                {{ errors.first('product_name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('product.nameEN') }}</label>
              <input
                type="text"
                v-model="model.product_name_en"
                class="form-control"
                :class="{ 'is-invalid': errors.has('product_name_en') }"
                :placeholder="$t('product.enterproductnameEN')"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_name_en')"
              >
                {{ errors.first('product_name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('product.category') }}</label>
              <select
                v-model="model.category_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('category_id') }"
                @change="getBarcode"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(category, index) in categories"
                  :key="index"
                  :value="category.category_id"
                >
                  {{ category.category_name_en }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('category_id')">
                {{ errors.first('category_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label>
                {{ $t('product.barcode') }}
                <i class="fas fa-spinner spin" v-if="getting_barcode"></i>
              </label>
              <input
                type="text"
                v-model.trim="model.barcode"
                class="form-control"
                :class="{ 'is-invalid': errors.has('barcode') }"
                :placeholder="$t('product.barcode')"
              />
              <div class="invalid-feedback" v-if="errors.has('barcode')">
                {{ errors.first('barcode') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('product.uomCategory') }}</label>
              <select
                v-model="model.uom_cat_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('uom_cat_id') }"
                :disabled="model.barcode == ''"
                @change="getSaleCodeList"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(uomcategory, index) in uomcategories"
                  :key="index"
                  :value="uomcategory.uom_cat_id"
                >
                  {{ uomcategory.uom_cat_name_en }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('uom_cat_id')">
                {{ errors.first('uom_cat_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <ts-checkbox v-model="model.is_expired">{{
                $t('product.expirationAvailable')
              }}</ts-checkbox>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-col-lg-9 col-md-9 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-12">
                <table class="table ui-table table-hover">
                  <thead>
                    <tr>
                      <th style="width: 20%">{{ $t('product.uom') }}</th>
                      <th>{{ $t('product.salecode') }}</th>
                      <th style="width: 25%">
                        {{ $t('product.quantityInHand') }}
                      </th>
                      <th style="width: 15%" class="text-center">
                        {{ $t('product.costprice') }}
                      </th>
                      <th style="width: 15%" class="text-center">
                        {{ $t('product.saleprice') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="getting_sale_code == true">
                      <th colspan="5" class="text-center">
                        <div>
                          <i class="fas fa-spinner spin fa-2x"></i>
                        </div>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in model.uom_id_list" :key="index">
                      <td>
                        <input
                          type="text"
                          v-model="item.uom_name"
                          class="form-control-plaintext"
                          :placeholder="$t('product.unitofmeasure')"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          v-model="item.sale_code"
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'uom_id_list.' + index + '.sale_code'
                            )
                          }"
                          :placeholder="$t('product.salecode')"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors.has('uom_id_list.' + index + '.sale_code')
                          "
                        >
                          {{
                            errors.first('uom_id_list.' + index + '.sale_code')
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.quantity_in_hand"
                          step="any"
                          class="form-control only-border-bottom"
                          :placeholder="$t('product.quantityInHand')"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.cost"
                          step="any"
                          class="form-control only-border-bottom text-center"
                          :class="{
                            'is-invalid': errors.has(
                              'uom_id_list.' + index + '.cost'
                            )
                          }"
                          :placeholder="$t('product.costPrice')"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="errors.has('uom_id_list.' + index + '.cost')"
                        >
                          {{ errors.first('uom_id_list.' + index + '.cost') }}
                        </div>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.sale_price"
                          step="any"
                          class="form-control only-border-bottom text-center"
                          :class="{
                            'is-invalid': errors.has(
                              'uom_id_list.' + index + '.sale_price'
                            )
                          }"
                          :placeholder="$t('product.saleprice')"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors.has('uom_id_list.' + index + '.sale_price')
                          "
                        >
                          {{
                            errors.first('uom_id_list.' + index + '.sale_price')
                          }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-right mt-2">
                <ts-button
                  class="btn-primary mr-2"
                  v-if="model.uom_id_list.length > 0"
                  @click.prevent="update"
                  :waiting="waiting"
                >
                  {{ $t('update') }}
                </ts-button>
                <ts-button
                  class="btn-default"
                  @click="$router.push({ name: 'product' })"
                >
                  {{ $t('cancel') }}
                </ts-button>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'product-edit',
  data() {
    return {
      model: {
        product_name_kh: '',
        product_name_en: '',
        category_id: '',
        barcode: '',
        uom_cat_id: '',
        is_expired: false,
        uom_id_list: []
      },
      errors: new Errors(),
      getting_barcode: false,
      getting_sale_code: false,
      waiting: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('product', ['categories', 'uomcategories', 'edit_data'])
  },
  methods: {
    getBarcode() {
      if (!this.model.category_id) {
        this.model.barcode = ''
        this.model.uom_cat_id = ''
        this.getSaleCodeList()
        return
      }
      this.getting_barcode = true
      this.$store
        .dispatch('product/getBarcode', this.model.category_id)
        .then(response => {
          this.getting_barcode = false
          this.model.barcode = response.barcode
          this.getSaleCodeList()
        })
        .catch(error => {
          this.getting_barcode = false
          this.$toasted.error(error.message)
        })
    },
    getSaleCodeList() {
      this.getting_sale_code = true
      this.$store
        .dispatch('product/getSaleCode', {
          uom_cat_id: this.model.uom_cat_id,
          product_id: this.model.product_id,
          product_barcode: this.model.barcode
        })
        .then(response => {
          this.model.uom_id_list = []
          this.getting_sale_code = false
          response.map(e => {
            this.model.uom_id_list.push({
              cost: parseFloat(e.cost).toFixed(2),
              is_exist: e.is_expired,
              pro_sale_code_id: e.pro_sale_code_id,
              quantity_in_hand: e.quantity_in_hand,
              sale_code: e.sale_code,
              sale_price: parseFloat(e.sale_price).toFixed(2),
              uom_id: e.uom_id,
              uom_name: e.uom_name
            })
          })
        })
        .catch(error => {
          this.getting_sale_code = false
          this.$toasted.error(error.message)
        })
    },
    setEditData() {
      this.model = {
        product_id: this.edit_data.product_id,
        product_name_kh: this.edit_data.product_name_kh,
        product_name_en: this.edit_data.product_name_en,
        category_id: this.edit_data.category_id,
        barcode: this.edit_data.barcode,
        uom_cat_id: this.edit_data.uom_cat_id,
        is_expired: this.edit_data.is_expired,
        uom_id_list: []
      }
      this.getSaleCodeList()
    },
    update() {
      this.waiting = true
      this.$store
        .dispatch('product/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product' })
        })
        .catch(error => {
          this.waiting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
